// Utility to generate base58 IDs with a prefix for database rows
// Base58 alphabet (no 0, O, I, l for readability)
const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

// Map of table names to id prefixes
export const TABLE_PREFIXES = {
  settings: 'setg',
  user_details: 'usrd',
  characters: 'chr',
  chats: 'chat',
  media_requests: 'mr',
  messages: 'msg',
  subscriptions: 'esub',
  transactions: 'tr',
};

function getRandomBytes(length: number): Uint8Array {
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    const arr = new Uint8Array(length);
    window.crypto.getRandomValues(arr);
    return arr;
  } else {
    // Fallback
    const arr = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      arr[i] = Math.floor(Math.random() * 256);
    }
    return arr;
  }
}

export function generateBase58Id(prefix: string): string {
  try {
    let result = '';
    const bytes = getRandomBytes(22);
    for (let i = 0; i < 22; i++) {
      result += BASE58_ALPHABET.charAt(bytes[i] % BASE58_ALPHABET.length);
    }
    return `${prefix}_${result}`;
  } catch (err) {
    // Fallback to Math.random
    if (import.meta.env.DEV) {
      console.log('[DEV] generateBase58Id:', err);
    }
    let result = '';
    for (let i = 0; i < 22; i++) {
      result += BASE58_ALPHABET.charAt(Math.floor(Math.random() * BASE58_ALPHABET.length));
    }
    return `${prefix}_${result}`;
  }
}

export function getIdWithoutPrefix(id: string): string {
  return id.split('_')[1];
}
